import axios from 'axios';

export default() => {
  return axios.create({
    baseURL: '/minisite',
  })
}



// WEBPACK FOOTER //
// ./src/api.js